
import { Component, Vue, Watch } from 'nuxt-property-decorator'

@Component
export default class extends Vue {
  isShowFooter: boolean = true
  isShowBlock: boolean = true

  @Watch('$route', { deep: true, immediate: true })
  change () {
    const routeName = this.$route.name || ''
    this.isShowFooter = !['gibdd-incoming', 'payment', 'payment-fail', 'search-gibdd', 'search-fns', 'mail'].includes(routeName)
    this.isShowBlock = !(this.$route.name === 'search-gibdd' || this.$route.name === 'search-fns')
  }

  currentYear (): number {
    return new Date().getFullYear()
  }
}
